export var SubscriptionStatus;
(function (SubscriptionStatus) {
    SubscriptionStatus["UNKNOWN"] = "UNKNOWN";
    /** Subscription created in this status, but hasn't been paid for yet. Filtered out from subscriptions querying. */
    SubscriptionStatus["DRAFT"] = "DRAFT";
    /** Subscription that will be active in future. */
    SubscriptionStatus["PENDING"] = "PENDING";
    /** Subscription is active */
    SubscriptionStatus["ACTIVE"] = "ACTIVE";
    /** Subscription is paused */
    SubscriptionStatus["PAUSED"] = "PAUSED";
    /** Subscription was ended */
    SubscriptionStatus["ENDED"] = "ENDED";
    /** Subscription was canceled or auto-renew off. Ended before its time. */
    SubscriptionStatus["CANCELED"] = "CANCELED";
})(SubscriptionStatus || (SubscriptionStatus = {}));
export var CollectionMethod;
(function (CollectionMethod) {
    CollectionMethod["UNKNOWN"] = "UNKNOWN";
    /** Subscriber automatically charged */
    CollectionMethod["AUTO_CHARGE"] = "AUTO_CHARGE";
    /** Payments manually collected and managed by owner */
    CollectionMethod["OFFLINE"] = "OFFLINE";
    /** Payment will be collected somehow. Billing only issues invoice per cycle. */
    CollectionMethod["SEND_INVOICE"] = "SEND_INVOICE";
    /** Payment will be collected externally */
    CollectionMethod["EXTERNAL"] = "EXTERNAL";
    /** Indicates the product has a zero amount, meaning its free with no payment required. */
    CollectionMethod["FREE"] = "FREE";
})(CollectionMethod || (CollectionMethod = {}));
export var DurationUnit;
(function (DurationUnit) {
    DurationUnit["UNKNOWN"] = "UNKNOWN";
    DurationUnit["DAY"] = "DAY";
    DurationUnit["WEEK"] = "WEEK";
    DurationUnit["MONTH"] = "MONTH";
    DurationUnit["YEAR"] = "YEAR";
})(DurationUnit || (DurationUnit = {}));
export var AdditionalFeeTrigger;
(function (AdditionalFeeTrigger) {
    AdditionalFeeTrigger["UNKNOWN"] = "UNKNOWN";
    /** Charge upon subscription first payment */
    AdditionalFeeTrigger["FIRST_PAYMENT"] = "FIRST_PAYMENT";
})(AdditionalFeeTrigger || (AdditionalFeeTrigger = {}));
export var TaxableAddressType;
(function (TaxableAddressType) {
    TaxableAddressType["UNKNOWN"] = "UNKNOWN";
    /** Tax will be calculated using a single address */
    TaxableAddressType["BUSINESS"] = "BUSINESS";
    /** Tax will be calculated using multiple address (from BUSINESS to BILLING) */
    TaxableAddressType["BILLING"] = "BILLING";
    /** Tax will be calculated using multiple address (from BUSINESS to SHIPPING) */
    TaxableAddressType["SHIPPING"] = "SHIPPING";
})(TaxableAddressType || (TaxableAddressType = {}));
export var PaymentStatus;
(function (PaymentStatus) {
    /** Payment status unknown */
    PaymentStatus["UNKNOWN"] = "UNKNOWN";
    /** Payment has not been paid */
    PaymentStatus["UNPAID"] = "UNPAID";
    /** Payment has been paid // TODO: p13n review: we are not sending event when in SEND_INVOICE mode cycle was paid. should we and which event? */
    PaymentStatus["PAID"] = "PAID";
    /** Payment failed */
    PaymentStatus["FAILED"] = "FAILED";
})(PaymentStatus || (PaymentStatus = {}));
export var PausePolicy;
(function (PausePolicy) {
    PausePolicy["NONE"] = "NONE";
    /** Pause the payment and the service. When resuming, the subscription end date is extended by the number of cycles postponed, and if the pause happened in a middle of a cycle, the payment date is postponed by the amount of days that already paid. */
    PausePolicy["SERVICE_AND_PAYMENTS"] = "SERVICE_AND_PAYMENTS";
    /** Pause the service and continue the billing. When resuming, extend the service by the time that was paused */
    PausePolicy["SERVICE_ONLY"] = "SERVICE_ONLY";
})(PausePolicy || (PausePolicy = {}));
export var PauseAt;
(function (PauseAt) {
    /** Cancel scheduled pause */
    PauseAt["NONE"] = "NONE";
    /** Pause the subscription now */
    PauseAt["IMMEDIATELY"] = "IMMEDIATELY";
    /** Pause the subscription at the next billing date */
    PauseAt["NEXT_BILLING_DATE"] = "NEXT_BILLING_DATE";
    /** A specific date must be defined in Schedule.specific_date */
    PauseAt["SPECIFIC_DATE"] = "SPECIFIC_DATE";
    /** The number of cycles must be defined in Schedule.number_of_cycles */
    PauseAt["NUMBER_OF_CYCLES_FROM_TODAY"] = "NUMBER_OF_CYCLES_FROM_TODAY";
})(PauseAt || (PauseAt = {}));
export var ResumeAt;
(function (ResumeAt) {
    /** Cancel scheduled resume */
    ResumeAt["NONE"] = "NONE";
    /** Resume the subscription now */
    ResumeAt["IMMEDIATELY"] = "IMMEDIATELY";
    /** Resume the subscription at the next billing date */
    ResumeAt["NEXT_BILLING_DATE"] = "NEXT_BILLING_DATE";
    /** A specific date must be defined in Schedule.specific_date */
    ResumeAt["SPECIFIC_DATE"] = "SPECIFIC_DATE";
})(ResumeAt || (ResumeAt = {}));
export var HistoryActionInitiator;
(function (HistoryActionInitiator) {
    HistoryActionInitiator["UNDEFINED"] = "UNDEFINED";
    HistoryActionInitiator["BUSINESS"] = "BUSINESS";
    HistoryActionInitiator["CUSTOMER"] = "CUSTOMER";
    HistoryActionInitiator["SYSTEM"] = "SYSTEM";
    HistoryActionInitiator["PAYMENT_FAILURE"] = "PAYMENT_FAILURE";
})(HistoryActionInitiator || (HistoryActionInitiator = {}));
export var ItemCategory;
(function (ItemCategory) {
    ItemCategory["UNKNOWN"] = "UNKNOWN";
    ItemCategory["PHYSICAL"] = "PHYSICAL";
    ItemCategory["DIGITAL"] = "DIGITAL";
})(ItemCategory || (ItemCategory = {}));
export var HistoryViewMode;
(function (HistoryViewMode) {
    HistoryViewMode["UNKNOWN"] = "UNKNOWN";
    /** Comprehensive view including all history events. */
    HistoryViewMode["BACKOFFICE"] = "BACKOFFICE";
    /** User-centric view of the history. */
    HistoryViewMode["USER"] = "USER";
})(HistoryViewMode || (HistoryViewMode = {}));
export var UpdateAction;
(function (UpdateAction) {
    UpdateAction["NONE"] = "NONE";
    /** Update subscription immediately, please note proration for updates changing price are not yet supported */
    UpdateAction["IMMEDIATELY"] = "IMMEDIATELY";
    /** Request updates that will take affect only at the start of the next billing cycle. */
    UpdateAction["NEXT_BILLING_CYCLE"] = "NEXT_BILLING_CYCLE";
    /** Reset all pending updates */
    UpdateAction["RESET_PENDING_UPDATES"] = "RESET_PENDING_UPDATES";
    /** Request updates that will take affect only at a specific date. */
    UpdateAction["SPECIFIC_DATE"] = "SPECIFIC_DATE";
})(UpdateAction || (UpdateAction = {}));
export var PaymentSettlementMethod;
(function (PaymentSettlementMethod) {
    PaymentSettlementMethod["UNKNOWN"] = "UNKNOWN";
    /** System-defined payment settlement. */
    PaymentSettlementMethod["SYSTEM"] = "SYSTEM";
    /** Manually mark the payment as paid. */
    PaymentSettlementMethod["MARK_AS_PAID"] = "MARK_AS_PAID";
    /** Require the customer to pay immediately, by insert a new payment method. */
    PaymentSettlementMethod["CUSTOMER_PAY_NOW"] = "CUSTOMER_PAY_NOW";
})(PaymentSettlementMethod || (PaymentSettlementMethod = {}));
export var PaymentMode;
(function (PaymentMode) {
    PaymentMode["NONE"] = "NONE";
    /** The latest invoice of the subscription will be charged. */
    PaymentMode["CHARGE"] = "CHARGE";
    /** An authorization invoice with zero amount will be created. */
    PaymentMode["AUTHORIZATION"] = "AUTHORIZATION";
})(PaymentMode || (PaymentMode = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var SubscriptionStatusGroup;
(function (SubscriptionStatusGroup) {
    SubscriptionStatusGroup["UNKNOWN_STATUS_GROUP"] = "UNKNOWN_STATUS_GROUP";
    SubscriptionStatusGroup["ALL"] = "ALL";
    /** Union of ACTIVE, PAUSED and PENDING */
    SubscriptionStatusGroup["LIVE"] = "LIVE";
})(SubscriptionStatusGroup || (SubscriptionStatusGroup = {}));
export var ActionType;
(function (ActionType) {
    ActionType["NONE"] = "NONE";
    ActionType["CREATION"] = "CREATION";
    ActionType["CANCEL"] = "CANCEL";
    ActionType["CYCLE_AUTO_RENEW_ON"] = "CYCLE_AUTO_RENEW_ON";
    ActionType["CYCLE_AUTO_RENEW_OFF"] = "CYCLE_AUTO_RENEW_OFF";
    ActionType["PAUSE"] = "PAUSE";
    ActionType["RESUME"] = "RESUME";
    ActionType["MARK_AS_PAID"] = "MARK_AS_PAID";
    ActionType["EXTEND"] = "EXTEND";
    ActionType["UPDATE"] = "UPDATE";
    ActionType["UPDATE_START_DATE"] = "UPDATE_START_DATE";
    ActionType["UPM"] = "UPM";
    ActionType["UPDATE_BILLING_DATE"] = "UPDATE_BILLING_DATE";
    ActionType["UPDATE_COLLECTION_METHOD"] = "UPDATE_COLLECTION_METHOD";
})(ActionType || (ActionType = {}));
export var ExtendPolicyType;
(function (ExtendPolicyType) {
    ExtendPolicyType["PERIOD"] = "PERIOD";
    ExtendPolicyType["BILLING_CYCLE"] = "BILLING_CYCLE";
})(ExtendPolicyType || (ExtendPolicyType = {}));
export var OrderMethod;
(function (OrderMethod) {
    OrderMethod["UNKNOWN"] = "UNKNOWN";
    OrderMethod["MOTO"] = "MOTO";
    OrderMethod["NOT_MOTO"] = "NOT_MOTO";
})(OrderMethod || (OrderMethod = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
export var ActionInitiator;
(function (ActionInitiator) {
    ActionInitiator["UNDEFINED"] = "UNDEFINED";
    ActionInitiator["BUSINESS"] = "BUSINESS";
    ActionInitiator["CUSTOMER"] = "CUSTOMER";
    ActionInitiator["SYSTEM"] = "SYSTEM";
})(ActionInitiator || (ActionInitiator = {}));
export var RequestedFields;
(function (RequestedFields) {
    RequestedFields["UNKNOWN_REQUESTED_FIELD"] = "UNKNOWN_REQUESTED_FIELD";
    /** Include unsupported action list, including the reasons for the lack of support */
    RequestedFields["UNSUPPORTED_ACTION"] = "UNSUPPORTED_ACTION";
})(RequestedFields || (RequestedFields = {}));
export var InvoiceStatus;
(function (InvoiceStatus) {
    InvoiceStatus["UNKNOWN"] = "UNKNOWN";
    InvoiceStatus["OPEN"] = "OPEN";
    InvoiceStatus["PAID"] = "PAID";
    InvoiceStatus["FAILED"] = "FAILED";
    InvoiceStatus["ATTEMPT_FAILED"] = "ATTEMPT_FAILED";
    InvoiceStatus["CANCELED"] = "CANCELED";
})(InvoiceStatus || (InvoiceStatus = {}));
export var CollectionMethodEnumCollectionMethod;
(function (CollectionMethodEnumCollectionMethod) {
    CollectionMethodEnumCollectionMethod["UNKNOWN"] = "UNKNOWN";
    CollectionMethodEnumCollectionMethod["AUTO_CHARGE"] = "AUTO_CHARGE";
    CollectionMethodEnumCollectionMethod["OFFLINE"] = "OFFLINE";
    CollectionMethodEnumCollectionMethod["SEND_INVOICE"] = "SEND_INVOICE";
})(CollectionMethodEnumCollectionMethod || (CollectionMethodEnumCollectionMethod = {}));
export var CreationMode;
(function (CreationMode) {
    CreationMode["UNKNOWN"] = "UNKNOWN";
    CreationMode["SYSTEM"] = "SYSTEM";
    CreationMode["MANUAL"] = "MANUAL";
})(CreationMode || (CreationMode = {}));
export var PaymentAttemptStatus;
(function (PaymentAttemptStatus) {
    PaymentAttemptStatus["UNKNOWN"] = "UNKNOWN";
    PaymentAttemptStatus["SCHEDULED"] = "SCHEDULED";
    PaymentAttemptStatus["IN_PROGRESS"] = "IN_PROGRESS";
    PaymentAttemptStatus["PAID"] = "PAID";
    PaymentAttemptStatus["DECLINED"] = "DECLINED";
    PaymentAttemptStatus["TECHNICAL_FAILURE"] = "TECHNICAL_FAILURE";
    PaymentAttemptStatus["CANCELED"] = "CANCELED";
    PaymentAttemptStatus["PENDING"] = "PENDING";
})(PaymentAttemptStatus || (PaymentAttemptStatus = {}));
export var IdentityType;
(function (IdentityType) {
    /** Identity type undefined */
    IdentityType["UNDEFINED"] = "UNDEFINED";
    /** Subscription is associated with a member ID */
    IdentityType["MEMBER"] = "MEMBER";
    /** Subscriptions is associated with a contact ID */
    IdentityType["CONTACT"] = "CONTACT";
})(IdentityType || (IdentityType = {}));
export var SubscriptionType;
(function (SubscriptionType) {
    SubscriptionType["UNDEFINED"] = "UNDEFINED";
    /** Payments made by the subscriber */
    SubscriptionType["ONLINE"] = "ONLINE";
    /** Payments managed manually by the site owner */
    SubscriptionType["OFFLINE"] = "OFFLINE";
})(SubscriptionType || (SubscriptionType = {}));
export var SubscriptionStatusEnumSubscriptionStatus;
(function (SubscriptionStatusEnumSubscriptionStatus) {
    /** Subscription status undefined */
    SubscriptionStatusEnumSubscriptionStatus["UNDEFINED"] = "UNDEFINED";
    /** Subscription created, but hasn't been paid for yet. This status if filtered out in ListSubscriptions response by default. */
    SubscriptionStatusEnumSubscriptionStatus["DRAFT"] = "DRAFT";
    /** Subscription has been paid for, but the start date is in the future */
    SubscriptionStatusEnumSubscriptionStatus["PENDING"] = "PENDING";
    /** Subscription is active */
    SubscriptionStatusEnumSubscriptionStatus["ACTIVE"] = "ACTIVE";
    /** Subscription has expired */
    SubscriptionStatusEnumSubscriptionStatus["EXPIRED"] = "EXPIRED";
    /** Subscription has been canceled */
    SubscriptionStatusEnumSubscriptionStatus["CANCELED"] = "CANCELED";
    /** Subscription has been set to be canceled at a future date */
    SubscriptionStatusEnumSubscriptionStatus["PENDING_CANCELLATION"] = "PENDING_CANCELLATION";
    /** Subscription is suspended */
    SubscriptionStatusEnumSubscriptionStatus["SUSPENDED"] = "SUSPENDED";
})(SubscriptionStatusEnumSubscriptionStatus || (SubscriptionStatusEnumSubscriptionStatus = {}));
export var PaymentStatusEnumPaymentStatus;
(function (PaymentStatusEnumPaymentStatus) {
    /** Payment status undefined */
    PaymentStatusEnumPaymentStatus["UNDEFINED"] = "UNDEFINED";
    /** Payment has been paid */
    PaymentStatusEnumPaymentStatus["PAID"] = "PAID";
    /** Payment has been refunded */
    PaymentStatusEnumPaymentStatus["REFUNDED"] = "REFUNDED";
    /** Recurring payment has failed */
    PaymentStatusEnumPaymentStatus["FAILED"] = "FAILED";
    /** Payment has not been paid */
    PaymentStatusEnumPaymentStatus["UNPAID"] = "UNPAID";
    /** Billing has been initialized, but actual charge is yet to be made. Can happen for free trial and PayPal */
    PaymentStatusEnumPaymentStatus["PENDING"] = "PENDING";
})(PaymentStatusEnumPaymentStatus || (PaymentStatusEnumPaymentStatus = {}));
/** Frequency unit of recurring payment */
export var SubscriptionFrequency;
(function (SubscriptionFrequency) {
    SubscriptionFrequency["UNDEFINED"] = "UNDEFINED";
    SubscriptionFrequency["DAY"] = "DAY";
    SubscriptionFrequency["WEEK"] = "WEEK";
    SubscriptionFrequency["MONTH"] = "MONTH";
    SubscriptionFrequency["YEAR"] = "YEAR";
})(SubscriptionFrequency || (SubscriptionFrequency = {}));
export var CancellationInitiator;
(function (CancellationInitiator) {
    /** Cancellation initiator undefined */
    CancellationInitiator["UNDEFINED"] = "UNDEFINED";
    /** Subscription was canceled by site owner (default if canceled by user or service identity) */
    CancellationInitiator["OWNER"] = "OWNER";
    /** Subscription was canceled by member (default if canceled by member identity) */
    CancellationInitiator["MEMBER"] = "MEMBER";
    /** Subscription was canceled because of payment failure */
    CancellationInitiator["PAYMENT_FAILURE"] = "PAYMENT_FAILURE";
    /** Subscription was canceled because of payment setup failure */
    CancellationInitiator["SETUP_FAILURE"] = "SETUP_FAILURE";
})(CancellationInitiator || (CancellationInitiator = {}));
export var Status;
(function (Status) {
    Status["UNDEFINED"] = "UNDEFINED";
    Status["ACTIVE"] = "ACTIVE";
    Status["ENDED"] = "ENDED";
})(Status || (Status = {}));
export var PaymentTestMode;
(function (PaymentTestMode) {
    PaymentTestMode["REGULAR"] = "REGULAR";
    PaymentTestMode["FAIL_TECHNICAL"] = "FAIL_TECHNICAL";
    PaymentTestMode["FAIL_DECLINE"] = "FAIL_DECLINE";
    PaymentTestMode["FAIL_RETRYABLE_DECLINE"] = "FAIL_RETRYABLE_DECLINE";
})(PaymentTestMode || (PaymentTestMode = {}));
export var RevivePolicy;
(function (RevivePolicy) {
    RevivePolicy["SIMPLE"] = "SIMPLE";
    RevivePolicy["RESUME"] = "RESUME";
})(RevivePolicy || (RevivePolicy = {}));
//# sourceMappingURL=types.impl.js.map